import ActionCableVue from 'actioncable-vue';
import Vue from 'vue';

export default ({ $config }) => {
  Vue.use(ActionCableVue, {
    connectImmediately: false,
    connectionUrl: `${$config.websocketHost}/cable/`,
    debug: $config.environment !== 'production',
    debugLevel: 'all'
  });
};
